import { useMutation, useQueryClient } from "@tanstack/react-query";
import { frappeMethod } from "@/lib/erp/utils";
import { toast } from "sonner";

/**
 * Restore an archived document (sets disabled=0).
 * Invalidates queries and shows toast. Does NOT navigate.
 */
export function useRestoreDoc(doctype: string) {
  const queryClient = useQueryClient();

  return useMutation<
    { success: boolean; message: string },
    Error,
    { name: string }
  >({
    mutationFn: ({ name }) =>
      frappeMethod<{ success: boolean; message: string }>(
        "zaviago_backend.api.archive.restore_doc",
        { doctype, name },
      ),
    onSuccess: (_data, { name }) => {
      if (doctype === "Item") {
        queryClient.invalidateQueries({ queryKey: ["item", name] });
        queryClient.invalidateQueries({ queryKey: ["items", "list"] });
      }
      const dtLower = doctype.toLowerCase().replace(/\s+/g, "-");
      queryClient.invalidateQueries({ queryKey: [dtLower, name] });
      queryClient.invalidateQueries({ queryKey: [dtLower + "s", "list"] });

      queryClient.invalidateQueries({ queryKey: ["archived-count"] });

      const label = doctype === "Item" ? "Product" : doctype;
      toast.success(`${label} restored.`);
    },
    onError: (error) => {
      toast.error(error.message || "Failed to restore");
    },
  });
}
